import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import {
  ParentQuestion,
  SearchQuestionsParams,
} from '../models/parent-question.model';
import { SearchQuestionsResponseDto } from './dtos/parent-question.dto';
import { ParentQuestionMapper } from './mappers/parent-question.mapper';
import { ParentQuestionPayloadMapper } from './mappers/parent-question-payload.mapper';

@Injectable({ providedIn: 'root' })
export class ParentQuestionApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);

  private readonly _parentQuestionMapper = new ParentQuestionMapper();
  private readonly _payloadMapper = new ParentQuestionPayloadMapper();

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;

  public searchQuestions(
    params: SearchQuestionsParams,
  ): Observable<ParentQuestion[]> {
    return this._http
      .get<SearchQuestionsResponseDto>(`${this._baseUrl}/search/questions`, {
        params: this._payloadMapper.toPayload(params),
      })
      .pipe(
        map((res) => this._parentQuestionMapper.fromDtoList(res.questions)),
      );
  }
}
